import { render, staticRenderFns } from "./detail_custom.vue?vue&type=template&id=35adfc6c&scoped=true"
import script from "./detail_custom.vue?vue&type=script&lang=js"
export * from "./detail_custom.vue?vue&type=script&lang=js"
import style0 from "./detail_custom.vue?vue&type=style&index=0&id=35adfc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35adfc6c",
  null
  
)

export default component.exports